// 12-question RED FLAG self-assessment.
// Distribution: 4 Beziehungen · 3 Psychologie · 2 Beruf · 2 Selbstwert · 1 Gesellschaft.
// Each answer carries a score 0/1/2/3 → total 0–36.

export const QUESTIONS = [
  // --- Beziehungen
  {
    id: "rel-1",
    category: "Beziehungen",
    de: {
      q: "Du erklärst dich in Diskussionen häufiger, als dass du verstanden wirst.",
    },
    en: { q: "In arguments you explain yourself more often than you feel understood." },
  },
  {
    id: "rel-2",
    category: "Beziehungen",
    de: {
      q: "Nach einem Streit zweifelst du an deiner eigenen Wahrnehmung.",
    },
    en: { q: "After a conflict you doubt your own perception of what happened." },
  },
  {
    id: "rel-3",
    category: "Beziehungen",
    de: {
      q: "Du passt dein Verhalten an die Stimmung der anderen Person an, bevor du nach Hause kommst.",
    },
    en: {
      q: "You adjust your behaviour to the other person's mood before you even come home.",
    },
  },
  {
    id: "rel-4",
    category: "Beziehungen",
    de: {
      q: "Du verschweigst Freund:innen oder Familie, was wirklich passiert.",
    },
    en: { q: "You hide from friends or family what's really happening." },
  },

  // --- Psychologie
  {
    id: "psy-1",
    category: "Psychologie",
    de: { q: "Du schläfst seit Monaten unruhig, ohne klar zu wissen, warum." },
    en: { q: "You've been sleeping restlessly for months without a clear reason." },
  },
  {
    id: "psy-2",
    category: "Psychologie",
    de: {
      q: "Wenn du ehrlich bist, wiederholt sich dasselbe Muster in deinen letzten drei Beziehungen.",
    },
    en: {
      q: "Honestly, the same pattern has repeated in your last three relationships.",
    },
  },
  {
    id: "psy-3",
    category: "Psychologie",
    de: {
      q: "Du redest dir Dinge schön, von denen du tief drin weißt, dass sie falsch sind.",
    },
    en: {
      q: "You talk yourself into things you deep down know are wrong.",
    },
  },

  // --- Beruf
  {
    id: "work-1",
    category: "Beruf",
    de: {
      q: "Sonntagabend macht dir körperlich schlecht — und das nicht zum ersten Mal.",
    },
    en: {
      q: "Sunday evenings make you physically ill — and not for the first time.",
    },
  },
  {
    id: "work-2",
    category: "Beruf",
    de: {
      q: "Du wirst in Meetings für Beiträge kleingemacht, die später als andere Idee gelobt werden.",
    },
    en: {
      q: "In meetings you get put down for contributions later praised as someone else's.",
    },
  },

  // --- Selbstwert
  {
    id: "self-1",
    category: "Selbstwert",
    de: {
      q: "Du sagst Ja zu Dingen, weil du Angst hast vor dem Gesicht beim Nein.",
    },
    en: { q: "You say yes to things because you fear the look you'd get for saying no." },
  },
  {
    id: "self-2",
    category: "Selbstwert",
    de: {
      q: "Komplimente fühlen sich wie eine Aufforderung an, mehr zu leisten.",
    },
    en: { q: "Compliments feel like an obligation to perform even more." },
  },

  // --- Gesellschaft
  {
    id: "soc-1",
    category: "Gesellschaft",
    de: {
      q: "Du teilst Meinungen, die nicht deine eigenen sind, damit du dazugehörst.",
    },
    en: { q: "You share opinions that aren't yours so you can belong." },
  },
];

export const ANSWERS = {
  de: [
    { value: 0, label: "Nein, gar nicht" },
    { value: 1, label: "Selten" },
    { value: 2, label: "Häufig" },
    { value: 3, label: "Ja, fast immer" },
  ],
  en: [
    { value: 0, label: "No, not at all" },
    { value: 1, label: "Rarely" },
    { value: 2, label: "Often" },
    { value: 3, label: "Yes, almost always" },
  ],
};

// Max possible: 12 * 3 = 36
export const TIERS = [
  {
    min: 0,
    max: 8,
    key: "clear",
    de: {
      label: "Klar",
      headline: "Wenig Red Flags. Bleib wach.",
      body:
        "Du scheinst gut bei dir zu sein. Trotzdem lohnt es sich, die eigenen Muster regelmäßig zu überprüfen — Bewusstsein ist das beste Frühwarnsystem.",
      cta: "RED FLAG Newsletter abonnieren",
    },
    en: {
      label: "Clear",
      headline: "Few red flags. Stay sharp.",
      body:
        "You seem grounded. Still — checking your patterns regularly is the best early-warning system. Awareness now is cheaper than recovery later.",
      cta: "Subscribe to the RED FLAG newsletter",
    },
  },
  {
    min: 9,
    max: 17,
    key: "watchful",
    de: {
      label: "Achtsam",
      headline: "Erste Warnsignale. Hinsehen lohnt sich.",
      body:
        "Da sind Muster, die dir wertvolle Energie kosten. Noch nichts Akutes, aber genau jetzt ist der richtige Moment, ehrlich hinzuschauen — bevor sich das Muster verfestigt.",
      cta: "Podcast: Die zehn größten Red Flags hören",
    },
    en: {
      label: "Watchful",
      headline: "First warning signs. Worth looking.",
      body:
        "Patterns are costing you energy. Nothing acute yet — but now is the moment to look honestly, before the pattern hardens.",
      cta: "Listen: The ten biggest red flags",
    },
  },
  {
    min: 18,
    max: 26,
    key: "warning",
    de: {
      label: "Warnsignale",
      headline: "Mehrere Red Flags. Handeln empfohlen.",
      body:
        "Was du beschreibst, ist kein Pech und kein Zufall. Mehrere Bereiche deines Lebens zeigen die gleichen Muster. Es ist Zeit, das nicht länger allein zu tragen.",
      cta: "SAT-Lösungspfad ansehen",
    },
    en: {
      label: "Warning",
      headline: "Multiple red flags. Action recommended.",
      body:
        "What you're describing isn't bad luck. Several areas of your life show the same pattern. Time to stop carrying it alone.",
      cta: "Explore the SAT path",
    },
  },
  {
    min: 27,
    max: 36,
    key: "alarm",
    de: {
      label: "Alarm",
      headline: "Akute Red-Flag-Lage. Bitte ernst nehmen.",
      body:
        "Mehrere starke Warnsignale gleichzeitig. Das ist kein Charakterfehler — das ist ein Signal. Bitte hol dir Unterstützung. SAT ist ein Weg. Eine qualifizierte Therapeut:in ein anderer. Tu jetzt einen Schritt.",
      cta: "SAT-Erstgespräch buchen",
    },
    en: {
      label: "Alarm",
      headline: "Acute red-flag situation. Take it seriously.",
      body:
        "Several strong warning signs at once. This isn't a character flaw — it's a signal. Please get support. SAT is one path. A qualified therapist is another. Take one step now.",
      cta: "Book a SAT intro session",
    },
  },
];

export function scoreToTier(total) {
  return TIERS.find((t) => total >= t.min && total <= t.max) || TIERS[0];
}
